import React from 'react';
import PropTypes from 'prop-types';
import Disclaimer from '../Disclaimer';
import './index.scss';

Content.propTypes = {
  data: PropTypes.string,
  isHeadline: PropTypes.bool,
  disclaimer: PropTypes.string
};

export function Content({ data, isHeadline, disclaimer }) {
  return (
    <article className="content">
      <article
        className="markdownBox"
        // eslint-disable-next-line
        dangerouslySetInnerHTML={{ __html: data }}
      />
      {
        isHeadline && <Disclaimer text={disclaimer} />
      }
    </article>
  );
}

export const NoContent = ({ text }) => {
  return (
    <article className="no-content">
      <h2>{text}</h2>
      <div className="image" />
    </article>
  );
};

NoContent.propTypes = {
  text: PropTypes.string.isRequired
};
